import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NumberFormat from "react-number-format";
import { Table } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Card } from "react-bootstrap";
import parse from "html-react-parser";
import { getPosSalesDetail } from "../../../../services/sales/posService";
import PosReceipt from "./posReceipt";
import { DialogActions, Typography } from "@material-ui/core";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../partials/content/Forms";
import Illustration from "../../../../partials/content/Illustration";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
function SalesPosDetail({ salesPosID = 0, onCloseDialog }) {
  const [salesPos, setSalesPos] = useState({
    ID: 0,
    payMethodName: "",
    salesName: "",
    createdByUser: { firstName: "" },
    cardNo: "",
    cardName: "",
    customer: { customerName: "" },
    currency: { currencyCode: "" },
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [itemsReturn, setItemsReturn] = useState([]);

  async function getPosSalesDateilData(salesPosID) {
    const response = await getPosSalesDetail(salesPosID);
    const { data } = response.data;
    setSalesPos(data.salesPos);
    setItemsReturn(data.itemsReturn);
  }

  useEffect(() => {
    getPosSalesDateilData(salesPosID);
  }, [salesPosID]);

  const itemsReturnDetailColumn = [
    {
      header: "Note",
      field: "note",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Point of Sales Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Point of Sales Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Point of Sales ID"
                            value={salesPos.ID}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Customer Name"
                            value={salesPos.customer.customerName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Sales Agent"
                            value={salesPos.salesName}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Payment Method"
                            value={salesPos.payMethodName}
                          />
                          {salesPos.payMethod === 4 ? (
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-6">
                                <CustomOutlinedDisabledTextField
                                  label="Card Number"
                                  value={salesPos.cardNo}
                                />
                              </div>
                              <div className="col-sm-12 col-md-12 col-lg-6">
                                <CustomOutlinedDisabledTextField
                                  label="Card Holder Name"
                                  value={salesPos.cardName}
                                />
                              </div>
                            </div>
                          ) : null}
                          <CustomOutlinedDisabledCurrencyField
                            label="Grand Total"
                            value={salesPos.total}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>POS Sales Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="card">
                                <Table
                                  striped
                                  borderless
                                  size="sm"
                                  responsive="xl"
                                >
                                  {salesPos.salesPosItem &&
                                  salesPos.salesPosItem.length > 0 ? (
                                    <thead>
                                      <tr>
                                        <th style={{ width: "25%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Item Name
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Receive Type
                                          </Typography>
                                        </th>
                                        <th style={{ width: "5%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Quantity
                                          </Typography>
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Batch ID
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Unit Price
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Item Discount
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Total Price
                                          </Typography>
                                        </th>
                                      </tr>
                                    </thead>
                                  ) : null}
                                  <tbody>
                                    {salesPos.salesPosItem &&
                                    salesPos.salesPosItem.length > 0 ? (
                                      salesPos.salesPosItem.map(
                                        (item, index) => (
                                          <tr
                                            key={index}
                                            className="border-top"
                                          >
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.itemName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.receiveTypeName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.qty} {item.uom.uomName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.batchID}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.unitPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {
                                                        salesPos.currency
                                                          .currencyCode
                                                      }{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.discountAmount}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {
                                                        salesPos.currency
                                                          .currencyCode
                                                      }{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.totalPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {
                                                        salesPos.currency
                                                          .currencyCode
                                                      }{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan="7"
                                        >
                                          <Illustration
                                            imageSource="INVIFO Sales.png"
                                            guidance="You don't have any POS Sales items yet"
                                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                            size="sm"
                                          ></Illustration>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6"></div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <Card>
                                <Card.Body className="pb-0">
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr className="border-bottom">
                                        <td style={{ width: "50%" }}>
                                          <Typography className="mb-3 kt-font-bolder">
                                            Sub Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="mb-3 kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={salesPos.subTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {
                                                    salesPos.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesPos.discountPercent}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Discount{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesPos.discountAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  -{" "}
                                                  {
                                                    salesPos.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesPos.taxPercent}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Tax{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesPos.taxAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {
                                                    salesPos.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            className="kt-font-bolder"
                                          >
                                            Grand Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={salesPos.total}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {
                                                    salesPos.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
            {salesPos.salesPosItem &&
            salesPos.salesPosItem.filter((item) => item.receiveType > 1)
              .length > 0 ? (
              <TabPanel header="Address" rightIcon="fas fa-map-marked-alt">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-map-marked-alt"></i>
                        <span>
                          <strong>Shipping Address</strong>
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <CustomOutlinedDisabledTextField
                              label="Ship To"
                              value={salesPos.recipient}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Address"
                              value={salesPos.address}
                            />
                            <CustomOutlinedDisabledTextField
                              label="City"
                              value={salesPos.city}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Province / State"
                              value={salesPos.province}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Phone Number"
                              value={salesPos.addressPhone}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Email"
                              value={salesPos.addressEmail}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Postal Code"
                              value={salesPos.postalCode}
                            />
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <CustomOutlinedDisabledTextField
                              label="Country"
                              value={salesPos.countryName}
                            />
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Address"
                rightIcon="fas fa-map-marked-alt"
                disabled
              ></TabPanel>
            )}
            <TabPanel header="Items Return" rightIcon="fas fa-box">
              {itemsReturn.length ? (
                <React.Fragment>
                  <CustomDataTable
                    data={itemsReturn}
                    dataDetailColumns={itemsReturnDetailColumn}
                    onRefreshData={() => {
                      getPosSalesDateilData(salesPosID);
                    }}
                    columns={[
                      {
                        header: "Item Type",
                        field: "itemTypeName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemTypeName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        hidden: true,
                      },
                      {
                        header: "Item Code",
                        field: "itemCode",
                        body: (rowData) => (
                          <React.Fragment>
                            {rowData.itemType > 0 ? (
                              <span>
                                <BootstrapTooltip title={rowData.itemTypeName}>
                                  <span className="mr-2">
                                    <i
                                      className={
                                        rowData.itemType === 1
                                          ? "fas fa-boxes text-success"
                                          : rowData.itemType === 2
                                          ? "fas fa-tools text-primary"
                                          : rowData.itemType === 3
                                          ? "fas fa-building text-info"
                                          : rowData.itemType === 4
                                          ? "fas fa-boxes text-warning"
                                          : rowData.itemType === 5
                                          ? "fas fa-boxes text-danger"
                                          : null
                                      }
                                    ></i>
                                  </span>
                                </BootstrapTooltip>
                                <span>
                                  <ResponsiveEllipsis
                                    text={rowData.itemCode}
                                    maxLine="1"
                                    displayInline
                                  />
                                </span>
                              </span>
                            ) : (
                              <React.Fragment>
                                <ResponsiveEllipsis
                                  text={rowData.itemCode}
                                  maxLine="1"
                                />
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Item Name",
                        field: "itemName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Returned Quantity",
                        field: "qtyReturn",
                        body: (rowData) => (
                          <div>
                            {rowData.qtyReturn} {rowData.uomName}
                          </div>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Unit",
                        field: "uomName",
                        body: null,
                        sortable: true,
                        hidden: true,
                      },
                      {
                        header: "Batch ID",
                        field: "batchID",
                        body: null,
                        sortable: true,
                      },
                      {
                        header: "Reason",
                        field: "reasonName",
                        body: null,
                        sortable: true,
                      },
                    ]}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Illustration
                    imageSource="INVIFO Inventory.png"
                    guidance={`You don't have any Returned Items for this goods issued yet`}
                    guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                    size="md"
                  ></Illustration>
                </React.Fragment>
              )}
            </TabPanel>
            <TabPanel header="Print Layout" rightIcon="fas fa-print">
              <PosReceipt
                salesData={salesPos}
                outletData={salesPos.outlet}
                userName={salesPos.createdByUser.firstName}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </React.Fragment>
  );
}

export default SalesPosDetail;
